import { render, staticRenderFns } from "./CartOrder.vue?vue&type=template&id=528b1539&"
import script from "./CartOrder.vue?vue&type=script&lang=js&"
export * from "./CartOrder.vue?vue&type=script&lang=js&"
import style0 from "./CartOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports